<template>
  <Bar :data="chartData" :options="chartOptions" class="custom-bar-chart" />
</template>

<script>
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "vue-chartjs";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

export default {
  props: {
    indexAxis: {
      default: "x",
    },
    label: {
      type: String,
      default: "Valor",
    },
    labels: {
      type: Array,
      default: [],
    },
    data: {
      type: Array,
      default: [],
    },
  },
  name: "BarChart",
  components: { Bar },
  data() {
    return {
      chartData: {
        labels: this.labels,
        datasets: [{ data: this.data, label: this.label }],
      },
      chartOptions: {
        responsive: true,
        indexAxis: this.indexAxis,
      },
    };
  },
};
</script>

<style>
.custom-bar-chart {
  max-height: 300px;
}
</style>
